import { variableAndDigitSearch } from '@app/const';
import { getPromptText, GetPromptTextProps } from './get-prompt-text';

/**
 * Whether the resolved prompt text for a language (+ optional TTS voice) contains
 * variables or digit placeholders — i.e. that lang/voice combo is dynamic.
 */
export function isTextDynamic(props: GetPromptTextProps): boolean {
  const text = getPromptText({
    ...props,
    variableParsing: undefined
  });
  return !!(text?.match(variableAndDigitSearch));
}
